enum OutageState {
  VISIBLE = "visible",
  ACTIVE = "active",
}

export default OutageState;
